module.exports = __webpack_public_path__ + "teqbahn-assets/media/impact4.a59b9db6.jpeg";